module.exports = __webpack_public_path__ + "fonts/NespressoLucas-MedItalic.woff?v=1119c43fbc1e29e431ed747f6b88fbfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-MedItalic.woff
// module id = 667
// module chunks = 0